/* lua.js generated code 0.3.0 */

require("clover/config/PlatformConfig")
UserDealData = {}
UserDealData.getGoodsIdForProp = function (propId) {
    var $st2 = MetaManager.getInstance().getGoodsMetaRef()
    for (var i in $st2) {
        var v = $st2[i]
        if ($len(v.items) === 1 && v.items[1].itemId === propId && v.items[1].num === 1 && (v.coin !== 0 || v.qCash !== 0 && v.discountQCash === 0)) {
            return v.id
        }
    }
    return null
}
UserDealData.getDiscountGoodsIdIfAvaliable = function (goodsId, num) {
    num = num || 1
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    if (!goodsMeta) {
        return null
    }
    var itemStr = ""
    for (var i = 1, v = goodsMeta.items[1]; v; i++, v = goodsMeta.items[i]) {
        itemStr = itemStr + "," + tostring(v.itemId) + ":" + tostring(v.num)
    }
    var $st9 = MetaManager.getInstance().getGoodsMetaRef()
    for (var i in $st9) {
        var v = $st9[i]
        var vItemStr = ""
        for (var j = 1, w = v.items[1]; w; j++, w = v.items[j]) {
            vItemStr = vItemStr + "," + tostring(w.itemId) + ":" + tostring(w.num)
        }
        if (itemStr === vItemStr && ((goodsMeta.qCash !== 0 && goodsMeta.qCash === v.qCash && v.discountQCash !== 0) || (goodsMeta.rmb !== 0 && goodsMeta.rmb === v.rmb && v.discountRmb !== 0)) && (v.limit <= 0 || UserManager.getInstance().getDailyData().getBuyedGoodsNumber(v.id) + num <= v.limit)) {
            return v.id
        }
    }
    return null
}
UserDealData.getGoodsPayType = function (goodsId) {
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    if (!goodsMeta) {
        return UserDealPayType.kUnsupport
    }
    if (goodsMeta.coin !== 0) {
        return UserDealPayType.kCoin
    } else if (goodsMeta.qCash !== 0) {
        return UserDealPayType.kCash
    } else {
        return UserDealPayType.kUnsupport
    }
}
UserDealData.getGoodsBuyCountLimit = function (goodsId) {
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    if (goodsMeta.limit <= 0) {
        return -1
    } else {
        // WARN: maybe multi result
        return Math.max(goodsMeta.limit - (UserManager.getInstance().getDailyData().getBuyedGoodsNumber(goodsMeta.id) || 0), 0)
    }
}
UserDealData.getGoodsDiscount = function (goodsId) {
    var meta = MetaManager.getInstance().getGoodsMeta(goodsId)
    if (!meta) {
        return 0
    }
    var payType = UserDealData.getGoodsPayType(goodsId)
    if (payType === UserDealPayType.kCash) {
        return meta.discountQCash / meta.qCash * 10
    } else {
        return 0
    }
}
UserDealData.getPayTypeByTag = function (tag) {
    return UserProductPayTypeRef[tag] || UserDealPayType.kUnsupport
}
UserDealData.getPayTagByType = function (tye) {
    for (var k in UserProductPayTypeRef) {
        var v = UserProductPayTypeRef[k]
        if (v === tye) {
            // WARN: maybe multi result
            return string.lower(k)
        }
    }
    return "unsupport"
}
